module.exports = __webpack_public_path__ + "static/img/Artelia_Logo.17fa0ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Artelia_Logo.png
// module id = p4AQ
// module chunks = 0